// coverage-calculator.js
(function () {
    const CONFIG = {
        resin: {
            standardVid: 'gid://shopify/ProductVariant/48667583447331',
            mtVid: 'gid://shopify/ProductVariant/48667583316259',
            // "Vuba 4 Graded Resins" — one variant per grade
            gradedVids: {
                grade1: 'gid://shopify/ProductVariant/62790465945987',
                grade2: 'gid://shopify/ProductVariant/62790465978755',
                grade3: 'gid://shopify/ProductVariant/62790466011523',
                grade4: 'gid://shopify/ProductVariant/62790466044291'
            }
        },
        mesh: {
            roll40Vid: 'gid://shopify/ProductVariant/53281808941443',
            roll130Vid: 'gid://shopify/ProductVariant/47948814614819'
        },
        vubamacVid: 'gid://shopify/ProductVariant/56742448595331',
        macmixVid: 'gid://shopify/ProductVariant/56742485787011',
        vubamacResinVid: 'gid://shopify/ProductVariant/47672392909091',
        bindingQuartzVid: 'gid://shopify/ProductVariant/47537887281443',
        BQ_PER_BAG: 1,
        wastageAddsToTotal: true,
        trowelCleanerVid: 'gid://shopify/ProductVariant/46755217309987',
        continuationVid: 'gid://shopify/ProductVariant/53262340686211'

    };

    const KIT_COVERAGE_M2 = 4;

    // Which resin variant the chosen "Resin Type?" tab maps to.
    // "graded" has a second row of tabs, so it needs the grade as well.
    function resolveResinVid(resinMode, grade) {
        if (resinMode === 'standard') return CONFIG.resin.standardVid;
        if (resinMode === 'graded') {
            return CONFIG.resin.gradedVids[grade] || CONFIG.resin.gradedVids.grade1;
        }
        return CONFIG.resin.mtVid;
    }

    // Manual image fallbacks 
    const MANUAL_IMAGES = {
        'gid://shopify/ProductVariant/48667583447331': 'https://www.vubasurfaces.co.uk/cdn/shop/files/Front_Central_1_4.png?v=1760023746&width=200',
        'gid://shopify/ProductVariant/48667583316259': 'https://www.vubasurfaces.co.uk/cdn/shop/files/Front_Central_1_4.png?v=1760023746&width=200',
        'gid://shopify/ProductVariant/56742448595331': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/VubaMacBaseAggregate_2_-01.png?v=1759997766&width=200',
        'gid://shopify/ProductVariant/56742485787011': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/VubaMacBaseAggregatexMacMix-01.png?v=1759322749&width=200',
        'gid://shopify/ProductVariant/47537887281443': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/IMG_0483.png?v=1750681202&width=200',
        'gid://shopify/ProductVariant/53281808941443': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/mesh.png?v=1744906277&width=200',
        'gid://shopify/ProductVariant/47948814614819': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/mesh.png?v=1744906277&width=200',
        'gid://shopify/ProductVariant/47672392909091': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/VubaMacTop.png?v=1750099128&width=200',
        'gid://shopify/ProductVariant/53262340686211': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/Vuba_Surface_Logo_png_no_back-01_cc79f553-0d55-4313-a38e-8035fcc67c12.webp?v=1763552163&width=200'
    };

    const PLACEHOLDER_DATA_URI =
        'data:image/svg+xml;utf8,' +
        encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128">
      <rect width="100%" height="100%" fill="#f4f4f5"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#a1a1aa" font-family="system-ui" font-size="12">No image</text>
    </svg>`);

    const sf = () => window.ShopifyStorefront || {};
    const VARIANTS = () => (window.VUBA_VARIANTS = window.VUBA_VARIANTS || {});
    const COLORS = () => (window.VUBA_PRODUCTS = window.VUBA_PRODUCTS || {});

    // ---------- Utils ----------
    function number(x) { return parseFloat(x || '0') || 0; }
    function selectedVal(form, nameStartsWith) {
        const el = form.querySelector(`input[type="radio"][name^="${nameStartsWith}"]:checked`);
        return el ? el.value : null;
    }
    function gidToNumeric(id) {
        if (!id) return null;
        const parts = String(id).split('/');
        return parts[parts.length - 1] || null;
    }

    function ensureMount(resultsBox) {
        let mount = resultsBox.querySelector('.coverage-calculator__product-list');
        if (!mount) {
            mount = document.createElement('div');
            mount.className = 'coverage-calculator__product-list grid gap-3';
            const cta = resultsBox.querySelector('#calculator-add-to-cart');
            (cta ? cta.before(mount) : resultsBox.appendChild(mount));
        }
        return mount;
    }
    function ensureErrorBox(resultsBox) {
        let err = resultsBox.querySelector('.cc-errors');
        if (!err) {
            err = document.createElement('div');
            err.className = 'cc-errors text-red-600 text-sm mb-2';
            err.setAttribute('role', 'alert');
            err.setAttribute('aria-live', 'assertive');
            const cta = resultsBox.querySelector('#calculator-add-to-cart');
            (cta ? cta.before(err) : resultsBox.appendChild(err));
        }
        return err;
    }
    function clearErrors(resultsBox) {
        const err = ensureErrorBox(resultsBox);
        err.textContent = '';
        err.style.display = 'none';
    }
    function showError(resultsBox, msg) {
        const err = ensureErrorBox(resultsBox);
        err.textContent = msg;
        err.style.display = '';
    }

    function selectedRadioLabel(form, nameStartsWith) {
        const el = form.querySelector(`input[type="radio"][name^="${nameStartsWith}"]:checked`);
        if (!el) return null;
        const lab = form.querySelector(`label[for="${el.id}"]`);
        return lab ? lab.textContent.trim() : null;
    }

    // ---------- Storefront fetch (hybrid: GraphQL -> AJAX fallback) ----------
    async function fetchVariantById(variantId) {
        if (!variantId) return null;
        const cache = VARIANTS();
        const cached = cache[variantId];
        const hasPriceField = cached && Object.prototype.hasOwnProperty.call(cached, 'priceAmount');
        const hasAnyImage = cached && (cached.imageUrl || cached.productImageUrl);
        if (hasPriceField && hasAnyImage) return cached;
        // Helper: format from GraphQL node
        const fromGraphQL = (v) => {
            if (!v) return null;
            // Handle both modern (price) and legacy (priceV2)
            const priceNode = v.price || v.priceV2;
            const compareAtNode = v.compareAtPrice || v.compareAtPriceV2;

            const priceAmount = parseFloat(priceNode?.amount || '0') || 0;
            const currency = priceNode?.currencyCode || (window.Shopify?.currency?.active) || 'GBP';
            const compareAt = parseFloat(compareAtNode?.amount || '0') || 0;

            return {
                title: v.title || '',
                imageUrl: v.image?.url || '',
                imageAlt: v.image?.altText || v.title || '',
                productTitle: v.product?.title || '',
                productImageUrl: v.product?.featuredImage?.url || '',
                productImageAlt: v.product?.featuredImage?.altText || (v.product?.title || ''),
                priceAmount,
                currency,
                compareAtAmount: compareAt
            };
        };

        // Helper: AJAX fallback (/variants/{id}.js)
        const fromAjax = async (vid) => {
            try {
                const numeric = gidToNumeric(vid);
                if (!numeric) return null;
                const res = await fetch(`/variants/${numeric}.js`, { headers: { 'Accept': 'application/json' } });
                if (!res.ok) return null;
                const j = await res.json();
                const priceAmount = (j?.price || 0) / 100;             // cents -> money
                const compareAmount = (j?.compare_at_price || 0) / 100;
                const currency = (window.Shopify?.currency?.active) || 'GBP';
                // featured_image can be { src, alt }, sometimes null
                const imgSrc = j?.featured_image?.src || '';
                const imgAlt = j?.featured_image?.alt || j?.name || j?.title || 'Product';

                return {
                    title: j?.title || '',
                    imageUrl: imgSrc,
                    imageAlt: imgAlt,
                    productTitle: j?.name || j?.title || '',
                    productImageUrl: imgSrc,
                    productImageAlt: imgAlt,
                    priceAmount,
                    currency,
                    compareAtAmount: compareAmount
                };
            } catch {
                return null;
            }
        };

        // 1) Try GraphQL
        try {
            const { endpoint, token } = sf();
            if (endpoint && token) {
                const query = `
        query($id: ID!) {
          node(id: $id) {
            ... on ProductVariant {
              id
              title
              price     { amount currencyCode }     # modern
              priceV2   { amount currencyCode }     # legacy
              compareAtPrice   { amount currencyCode }
              compareAtPriceV2 { amount currencyCode }
              image { url(transform:{ maxWidth:300, preferredContentType: WEBP }) altText }
              product {
                title
                featuredImage { url(transform:{ maxWidth:300, preferredContentType: WEBP }) altText }
              }
            }
          }
        }`;
                const res = await fetch(endpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
                    body: JSON.stringify({ query, variables: { id: variantId } })
                });
                if (res.ok) {
                    const json = await res.json();
                    const datum = fromGraphQL(json?.data?.node);
                    if (datum && (datum.priceAmount > 0 || datum.imageUrl || datum.productImageUrl)) {
                        if (!datum.imageUrl && !datum.productImageUrl) {
                            const manual = MANUAL_IMAGES[variantId];
                            if (manual) {
                                datum.imageUrl = manual;
                                datum.imageAlt = datum.imageAlt || datum.title || 'Product';
                            }
                        }
                        cache[variantId] = datum;
                        return datum;
                    }
                }
            }
        } catch { /* fall through to AJAX */ }

        // 2) AJAX fallback
        const ajaxDatum = await fromAjax(variantId);
        if (ajaxDatum) {
            if (!ajaxDatum.imageUrl && !ajaxDatum.productImageUrl) {
                const manual = MANUAL_IMAGES[variantId];
                if (manual) {
                    ajaxDatum.imageUrl = manual;
                    ajaxDatum.imageAlt = ajaxDatum.imageAlt || ajaxDatum.title || 'Product';
                }
            }
            cache[variantId] = ajaxDatum;
            return ajaxDatum;
        }

        return null;
    }

    function syncUnitsUI(formEl) {
        const legend = formEl.querySelector('[data-role="area-legend"]');
        const input = formEl.querySelector('[data-role="area-input"]');
        const mode = selectedVal(formEl, 'units-');

        const depthField = formEl.querySelector('[data-role="depth-field"]');
        const wastageField = formEl.querySelector('[data-role="wastage-field"]');

        const vmQtyWrap = formEl.querySelector('[data-role="vubamac-qty-wrapper"]');
        const vmM2Wrap = formEl.querySelector('[data-role="vubamac-m2-wrapper"]');
        const vmWastageWrap = formEl.querySelector('[data-role="vubamac-wastage-wrapper"]');
        const vmode = selectedVal(formEl, 'vubamac-');

        const meshKitsField = formEl.querySelector('[data-role="mesh-kits-field"]');
        const meshKitsQtyWrap = formEl.querySelector('[data-role="mesh-kits-qty-wrapper"]');
        const meshKitsQtyInput = formEl.querySelector('[data-role="mesh-kits-qty-input"]');
        const meshKitsHint = formEl.querySelector('[data-role="mesh-kits-requirement-text"]');

        const tcField = formEl.querySelector('[data-role="trowel-cleaner-field"]');
        const colorSelectWrapper = formEl.querySelector('[data-role="color-select-wrapper"]');
        const toppingChoice = selectedVal(formEl, 'topping-');
        const isToppingNeeded = (toppingChoice === 'yes');
        const wantsVm = (vmode === 'vubamac' || vmode === 'vubamac-macmix');

        // Show in BOTH modes
        if (tcField) tcField.style.display = '';
        if (colorSelectWrapper) colorSelectWrapper.style.display = isToppingNeeded ? '' : 'none';
        // Don't auto-uncheck when switching modes

        if (legend && input) {
            if (mode === 'kits') {
                legend.textContent = 'How many kits?';
                input.placeholder = 'Enter number of kits';
                input.step = '1';
            } else {
                legend.textContent = 'How many m²?';
                input.placeholder = 'Enter the area size';
                input.step = 'any';
            }
        }

        // Hide wastage in kits mode OR if topping not needed
        const hideToppingFields = (mode === 'kits' || !isToppingNeeded);
        if (wastageField) wastageField.style.display = hideToppingFields ? 'none' : '';

        // Depth (traffic type) field: hide only in kits mode, OR if BOTH topping is not needed AND VubaMac is not selected.
        // VubaMac kit quantity depends on the traffic type, so depth must stay visible when VubaMac is chosen
        // even if the stone topping is not needed.
        const hideDepthField = (mode === 'kits') || (!isToppingNeeded && !wantsVm);
        if (depthField) depthField.style.display = hideDepthField ? 'none' : '';

        // Also hide the Resin Type selection if topping not needed
        const resinTypeEl = formEl.querySelector('input[name^="resin-"]');
        if (resinTypeEl) {
            const resinField = resinTypeEl.closest('.coverage-calculator__field');
            if (resinField) resinField.style.display = isToppingNeeded ? '' : 'none';
        }

        // The grade tabs only make sense under the "Graded" resin type
        const gradeWrap = formEl.querySelector('[data-role="resin-grade-wrapper"]');
        if (gradeWrap) {
            const showGrades = isToppingNeeded && selectedVal(formEl, 'resin-') === 'graded';
            gradeWrap.style.display = showGrades ? '' : 'none';
        }

        // Manual VubaMac qty input only in kits mode AND only when VubaMac option selected
        const vmDetailsContainer = formEl.querySelector('[data-role="vubamac-details-container"]');

        if (vmDetailsContainer) {
            vmDetailsContainer.style.display = wantsVm ? '' : 'none';
        }

        if (vmQtyWrap) {
            const showVmQty = (mode === 'kits' && wantsVm);
            const vmQtyInput = vmQtyWrap.querySelector('[data-role="vubamac-qty-input"]');

            if (showVmQty) {
                vmQtyWrap.style.display = '';
                // Auto-populate with main input value if empty
                if (vmQtyInput && input && !vmQtyInput.value) {
                    const mainValue = Math.floor(number(input.value));
                    if (mainValue > 0) {
                        vmQtyInput.value = mainValue;
                    }
                }
            } else {
                vmQtyWrap.style.display = 'none';
                // Clear value when hiding
                if (vmQtyInput) vmQtyInput.value = '';
            }
        }

        // VubaMac m² input only in m² mode AND only when VubaMac option selected
        if (vmM2Wrap) {
            const showVmM2 = (mode === 'm2' && wantsVm);
            const vmM2Input = vmM2Wrap.querySelector('[data-role="vubamac-m2-input"]');

            if (showVmM2) {
                vmM2Wrap.style.display = '';
                // Auto-populate with main input value if empty OR if topping is not needed
                // This prevents overwriting user's manual edits, but resets when topping changes
                if (vmM2Input && input) {
                    const shouldReset = (!vmM2Input.value || !isToppingNeeded);
                    if (shouldReset) {
                        const mainValue = number(input.value);
                        if (mainValue > 0) {
                            vmM2Input.value = mainValue;
                        }
                    }
                }
            } else {
                vmM2Wrap.style.display = 'none';
                // Clear value when hiding to prevent state carryover
                if (vmM2Input) vmM2Input.value = '';
            }
        }

        // VubaMac wastage selection only in m² mode AND only when VubaMac option selected
        if (vmWastageWrap) {
            const showVmWastage = (mode === 'm2' && wantsVm);
            vmWastageWrap.style.display = showVmWastage ? '' : 'none';
        }

        if (meshKitsField) meshKitsField.style.display = (mode === 'kits') ? '' : 'none';

        // Always hide m² mesh opt-out in kits mode (but keep it for m² mode)
        const meshOptOutM2Field = formEl.querySelector('[data-role="mesh-optout-m2-field"]');
        if (meshOptOutM2Field) {
            const show = (mode === 'm2');
            meshOptOutM2Field.style.display = show ? '' : 'none';
            if (!show) {
                const cb = meshOptOutM2Field.querySelector('input[type="checkbox"]');
                if (cb) cb.checked = false;
            }
        }
    }

    // ---------- Calculator state (shared) ----------
    function computeState(formEl) {
        const areaInput = formEl.querySelector('[data-role="area-input"]');
        const unitsMode = selectedVal(formEl, 'units-'); // "m2" | "kits"
        const colorSelect = formEl.querySelector('select[id^="color-"]');

        const continuationCheckbox = formEl.querySelector('input[type="checkbox"][data-role="continuation-checkbox"]');
        const continuationInput = formEl.querySelector('[data-role="continuation-input"]');
        const vubamacQtyInput = formEl.querySelector('[data-role="vubamac-qty-input"]');
        const vubamacM2Input = formEl.querySelector('[data-role="vubamac-m2-input"]');
        const trowelCleanerCheckbox = formEl.querySelector('input[type="checkbox"][data-role="trowel-cleaner-checkbox"]');
        const inputValue = number(areaInput?.value);
        const depthFromUI = number(selectedVal(formEl, 'depth-'));
        const kitsDepthFromUI = number(selectedVal(formEl, 'kits-depth-')) || KIT_COVERAGE_M2;
        const wasteFromUI = number(selectedVal(formEl, 'overage-')) / 100;
        const resin = selectedVal(formEl, 'resin-');
        const resinGrade = selectedVal(formEl, 'grade-') || 'grade1';
        const vmode = selectedVal(formEl, 'vubamac-');
        const meshOptOutM2 = formEl.querySelector('input[type="checkbox"][data-role="mesh-optout-m2"]');
        const noMeshM2 = !!(meshOptOutM2 && meshOptOutM2.checked);

        const meshMode = selectedVal(formEl, 'meshmode-') || 'none';
        const meshKitsQtyInput = formEl.querySelector('[data-role="mesh-kits-qty-input"]');
        // ---- Determine AREA ----
        let depth = 0;
        let wastePc = 0;
        let areaRaw = 0;
        let kits = 0;

        if (unitsMode === 'kits') {
            kits = Math.floor(inputValue);
            // Coverage per kit depends on kits-depth selection:
            // Pedestrian: 4m²/kit, Vehicle: 3.5m²/kit, Heavy: 3.15m²/kit
            depth = kitsDepthFromUI;
            wastePc = 0;                 // wastage ignored in kits mode
            areaRaw = kits * depth;
        } else {
            depth = depthFromUI;
            wastePc = wasteFromUI;
            areaRaw = inputValue;
            kits = depth > 0 ? Math.ceil(areaRaw / depth) : 0;
        }

        // Apply wastage
        const areaWithWaste = (unitsMode === 'm2' && CONFIG.wastageAddsToTotal)
            ? areaRaw * (1 + wastePc)
            : areaRaw;

        // ---- Bags logic ----
        let bags = 0;
        const isToppingNeeded = selectedVal(formEl, 'topping-') === 'yes';

        if (isToppingNeeded) {
            if (unitsMode === 'kits') {
                bags = kits;
            } else if (areaWithWaste > 0 && depth > 0) {
                bags = Math.ceil(areaWithWaste / depth);
            }
        }

        // ---- VubaMac quantities ----
        let vmQty = 0;
        const wantsVm = (vmode === 'vubamac' || vmode === 'vubamac-macmix');

        if (wantsVm) {
            if (unitsMode === 'kits') {
                // Manual entry — NOT calculated from m²
                vmQty = Math.max(0, Math.floor(number(vubamacQtyInput?.value)));
            } else {
                // m² mode: Use VubaMac m² field if entered, otherwise use main area input
                let vubamacM2Value = number(vubamacM2Input?.value);
                const vmWastePc = number(selectedVal(formEl, 'vm-overage-')) / 100;

                // If VubaMac m² field is empty or 0, use the main area input
                if (vubamacM2Value <= 0) {
                    vubamacM2Value = areaRaw;
                }

                if (vubamacM2Value > 0) {
                    const vubamacM2WithWaste = vubamacM2Value * (1 + vmWastePc);

                    // Use depth/traffic-type divisor for VubaMac calculation (always, regardless of topping).
                    // Confirmed correct rates from client:
                    //   Foot Traffic 15mm  (depth=4)    → 5 sqm/kit    (100sqm = 20 kits)
                    //   Vehicle Traffic 30mm (depth=3.5) → 2.6 sqm/kit  (100sqm = 39 kits)
                    //   Heavy Vehicle 35mm  (depth=3.15) → 2.15 sqm/kit (100sqm = 47 kits)
                    let divisor = 0;
                    if (depth === 4) {
                        divisor = 5;    // Foot Traffic 15mm
                    } else if (depth === 3.5) {
                        divisor = 2.6;  // Vehicle Traffic 30mm
                    } else if (depth === 3.15) {
                        divisor = 2.15; // Heavy Vehicle 35mm
                    }
                    if (divisor > 0) vmQty = Math.ceil(vubamacM2WithWaste / divisor);
                }
            }
        }

        // ---- Colour ----
        const colorHandle = colorSelect?.value || '';
        const colorDatum = colorHandle ? COLORS()[colorHandle] : null;
        const colorVid = colorDatum?.variantId || null;

        // ---- Mesh ----
        const forceMesh = (vmode === 'vubamac' || vmode === 'vubamac-macmix');
        let meshQty = 0;
        let meshVid = null;

        if (unitsMode === 'kits') {
            // Kits mode: mesh is manual qty based on new selector
            if (meshMode !== 'none') {
                meshQty = Math.max(0, Math.floor(number(meshKitsQtyInput?.value)));
                if (meshQty > 0) meshVid = CONFIG.mesh.roll130Vid;
            }
        } else {
            // m² mode: keep existing behavior (auto mesh unless opted out, forced for vubamac)
            if (areaWithWaste > 0 && !noMeshM2) {
                meshVid = CONFIG.mesh.roll130Vid;
                const layers = (forceMesh && (depth === 3.5 || depth === 3.15)) ? 2 : 1;
                meshQty = Math.ceil((areaWithWaste * layers) / 130);
            } else {
                meshQty = 0;
                meshVid = null;
            }
        }

        // if (unitsMode === 'kits') {
        //   // Manual mesh entry (rolls)
        //   const overlayRollsRaw = Math.floor(number(overlayMeshInput?.value));
        //   const vubamacRollsRaw = Math.floor(number(vubamacMeshInput?.value));

        //   const overlayRolls = noMesh ? 0 : Math.max(0, overlayRollsRaw);
        //   const vubamacRolls = forceMesh ? Math.max(0, vubamacRollsRaw) : 0;

        //   meshQty = overlayRolls + vubamacRolls;

        //   if (meshQty > 0) meshVid = CONFIG.mesh.roll130Vid;
        // } else {
        //   // Existing m² behaviour stays unchanged
        //   if (areaWithWaste > 0 && (forceMesh || !noMesh)) {
        //     meshVid = CONFIG.mesh.roll130Vid;
        //     const layers = (forceMesh && (depth === 3.5 || depth === 3.15)) ? 2 : 1;
        //     meshQty = Math.ceil((areaWithWaste * layers) / 130);
        //   }
        // }

        return {
            unitsMode,
            area: areaRaw,
            areaWithWaste,
            kits,
            depth,
            wastePc,
            vmode,
            bags,
            vmQty,
            meshMode,
            meshQty,
            meshVid,
            colorVid,
            colorHandle,
            colorDatum,
            isToppingNeeded,
            resinMode: resin,
            resinGrade,
            resinVid: resolveResinVid(resin, resinGrade),
            vmVid: vmode === 'vubamac' ? CONFIG.vubamacVid : vmode === 'vubamac-macmix' ? CONFIG.macmixVid : null,
            bqVid: CONFIG.bindingQuartzVid,
            meshQty,
            meshVid,
            continuationEnabled: !!(continuationCheckbox && continuationCheckbox.checked),
            continuationOrderNumber: continuationInput?.value?.trim() || '',
            trowelCleanerEnabled: !!(trowelCleanerCheckbox && trowelCleanerCheckbox.checked)
        };
    }

    function formatMoney(amount, currency) {
        try {
            const code = currency || (window.Shopify?.currency?.active) || 'GBP';
            return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount || 0);
        } catch {
            return `£${(amount || 0).toFixed(2)}`;
        }
    }

    function setLoading(btn, isLoading) {
        if (!btn) return;
        if (isLoading) {
            btn.dataset.prevText = btn.textContent;
            btn.disabled = true;
            btn.classList.add('opacity-70', 'cursor-wait');
            btn.innerHTML = `
      <span class="inline-flex items-center gap-2 justify-center w-full">
        <span class="cc-spinner" aria-hidden="true"></span>
        Adding…
      </span>`;
            btn.setAttribute('aria-busy', 'true');
        } else {
            btn.disabled = false;
            btn.classList.remove('opacity-70', 'cursor-wait');
            btn.textContent = btn.dataset.prevText || 'Add To Cart';
            btn.removeAttribute('aria-busy');
        }
    }


    // ---------- Build cart lines from state ----------
    function collectCartLines(state) {
        const lines = [];

        if (state.bags > 0 && state.colorVid) {
            lines.push({ id: state.colorVid, quantity: state.bags });
        }
        if (state.bags > 0 && state.resinVid) {
            lines.push({ id: state.resinVid, quantity: state.bags });
        }
        if (state.vmQty > 0 && state.vmVid) {
            lines.push({ id: state.vmVid, quantity: state.vmQty });
        }

        // VubaMac Resin
        if (state.vmQty > 0 && CONFIG.vubamacResinVid) {
            lines.push({ id: CONFIG.vubamacResinVid, quantity: state.vmQty });
        }

        if (state.bags > 0 && state.bqVid) {
            const qty = CONFIG.BQ_PER_BAG > 0 ? state.bags * CONFIG.BQ_PER_BAG : state.bags;
            lines.push({ id: state.bqVid, quantity: qty });
        }
        if (state.meshQty > 0 && state.meshVid) {
            lines.push({ id: state.meshVid, quantity: state.meshQty });
        }

        if (state.continuationEnabled && CONFIG.continuationVid) {
            lines.push({ id: CONFIG.continuationVid, quantity: 1 });
        }

        if (state.trowelCleanerEnabled && CONFIG.trowelCleanerVid) {
            lines.push({ id: CONFIG.trowelCleanerVid, quantity: 1 });
        }

        const merged = {};
        lines.forEach(l => {
            merged[l.id] = (merged[l.id] || 0) + l.quantity;
        });

        return Object.entries(merged).map(([id, quantity]) => ({ id, quantity }));
    }

    // ---------- Renderer ----------
    function renderCard({ imageUrl, imageAlt, title, qty, unitPrice, currency }) {
        const wrap = document.createElement('div');
        wrap.className = 'cc-card flex items-center gap-3 p-3 rounded-xl border border-gray-200';
        const safeUrl = imageUrl || PLACEHOLDER_DATA_URI;
        const safeAlt = escapeHtml(imageAlt || title || 'Product');

        const showPrice = typeof unitPrice === 'number' && unitPrice > 0;
        const lineTotal = showPrice ? unitPrice * qty : 0;
        const priceHtml = showPrice
            ? `<div class="text-sm text-gray-600">${formatMoney(unitPrice, currency)} × ${qty} = <span class="font-semibold">${formatMoney(lineTotal, currency)}</span></div>`
            : `<div class="text-sm text-gray-500">Price unavailable</div>`;

        wrap.innerHTML = `
    <div class="cc-card__img w-16 h-16 rounded-lg overflow-hidden bg-gray-50 flex-shrink-0">
      <img src="${safeUrl}" alt="${safeAlt}" class="w-full h-full object-cover" loading="lazy">
    </div>
    <div class="cc-card__meta flex-1">
      <div class="font-medium leading-tight">${escapeHtml(title)}</div>
      ${priceHtml}
    </div>
    <div class="cc-card__qty text-right font-semibold">× ${qty}</div>
  `;
        return wrap;
    }
    function escapeHtml(s = '') {
        return s.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    async function pushVariantOrFallback(items, variantId, qty, fallbackTitle, opts = {}) {
        if (!(qty > 0)) return;

        const manualUrl = MANUAL_IMAGES[variantId];
        const forcedTitle = opts.forcedTitle || null;
        const altImageUrl = opts.altImageUrl || null;

        const baseItem = (title) => ({
            title,
            imageUrl: altImageUrl || manualUrl || PLACEHOLDER_DATA_URI,
            imageAlt: title,
            qty,
            unitPrice: 0,
            currency: (window.Shopify?.currency?.active) || 'GBP'
        });

        if (!variantId) {
            items.push(baseItem(forcedTitle || fallbackTitle));
            return;
        }

        const v = await fetchVariantById(variantId);

        if (v) {
            const computedTitle = (() => {
                const pt = (v.productTitle || '').trim();
                const vt = (v.title || '').trim();
                const vtIsDefault = /^default\s*title$/i.test(vt);
                if (!vt || vtIsDefault) return pt || fallbackTitle;
                if (pt.toLowerCase().includes(vt.toLowerCase())) return pt;
                return `${pt}${pt && vt ? ' — ' : ''}${vt}`;
            })();

            const titleOut = forcedTitle || computedTitle || fallbackTitle;

            const finalUrl = v.imageUrl
                || v.productImageUrl
                || altImageUrl
                || manualUrl
                || PLACEHOLDER_DATA_URI;

            const finalAlt = v.imageAlt || v.productImageAlt || titleOut;

            // override priceAmount with contextual (Liquid) price if available
            const numericId = gidToNumeric(variantId);
            const contextualMap = window.VUBA_CONTEXTUAL_PRICES || {};
            const contextualPrice = numericId ? contextualMap[numericId] : null;

            const unitPrice = (contextualPrice != null && !Number.isNaN(Number(contextualPrice)))
                ? Number(contextualPrice)
                : (v.priceAmount || 0);

            items.push({
                title: titleOut,
                imageUrl: finalUrl,
                imageAlt: finalAlt,
                qty,
                unitPrice,
                currency: v.currency || (window.Shopify?.currency?.active) || 'GBP'
            });
        } else {
            items.push(baseItem(forcedTitle || fallbackTitle));
        }
    }

    async function buildAndRender(formEl) {
        const resultsBox = formEl.querySelector('.coverage-calculator__form--results');
        if (!resultsBox) return;
        clearErrors(resultsBox);

        const mount = ensureMount(resultsBox);
        showLoading(mount);

        const state = computeState(formEl);
        const items = [];

        // Colour
        if (state.colorVid && state.bags > 0) {
            await pushVariantOrFallback(
                items,
                state.colorVid,
                state.bags,
                state.colorDatum?.title || 'Colour',
                {
                    altImageUrl:
                        state.colorDatum?.image?.src ||
                        state.colorDatum?.imageUrl ||
                        state.colorDatum?.image ||
                        null
                }
            );
        }

        // Resin
        if (state.bags > 0 && state.resinVid) {
            let choiceLabel = selectedRadioLabel(formEl, 'resin-') || (state.resinVid === CONFIG.resin.mtVid ? 'MT' : 'Standard');
            if (state.resinMode === 'graded') {
                choiceLabel = selectedRadioLabel(formEl, 'grade-') || 'Grade 1';
            }
            await pushVariantOrFallback(
                items,
                state.resinVid,
                state.bags,
                `Resin — ${choiceLabel}`,
                { forcedTitle: `Resin — ${choiceLabel}` }
            );
        }

        // VubaMac / MacMix
        if (state.vmQty > 0 && state.vmVid) {
            const forced = (state.vmode === 'vubamac-macmix') ? 'VubaMac & MacMix' : 'VubaMac Base';
            await pushVariantOrFallback(items, state.vmVid, state.vmQty, forced, { forcedTitle: forced });

            //  VubaMac Resin line 
            if (CONFIG.vubamacResinVid) {
                await pushVariantOrFallback(
                    items,
                    CONFIG.vubamacResinVid,
                    state.vmQty,
                    'VubaMac Resin',
                    { forcedTitle: 'VubaMac Resin' }
                );
            } else {
                await pushVariantOrFallback(items, null, state.vmQty, 'VubaMac Resin', { forcedTitle: 'VubaMac Resin' });
            }
        }

        // Binding Quartz
        if (state.bags > 0 && state.bqVid) {
            await pushVariantOrFallback(items, state.bqVid, state.bags * CONFIG.BQ_PER_BAG, 'Binding Quartz');
        }

        if (state.trowelCleanerEnabled && CONFIG.trowelCleanerVid) {
            await pushVariantOrFallback(
                items,
                CONFIG.trowelCleanerVid,
                1,
                'Trowel cleaner',
                { forcedTitle: 'Trowel cleaner' }
            );
        }

        // Mesh
        if (state.meshQty > 0 && state.meshVid) {
            const label = 'Mesh — 130m²';
            await pushVariantOrFallback(items, state.meshVid, state.meshQty, label);
        }

        if (state.continuationEnabled && CONFIG.continuationVid) {
            await pushVariantOrFallback(
                items,
                CONFIG.continuationVid,
                1,
                'Continuation order',        // fallback title
                { forcedTitle: 'Continuation order' }
            );
        }
        mount.innerHTML = ''; // clear loader

        if (items.length === 0) {
            mount.innerHTML = `<div class="text-gray-500">No products to display yet.</div>`;
            return;
        }

        // Render cards
        items.forEach(item => mount.appendChild(renderCard(item)));

        // Render grand total (sum only items with a known price)
        const firstCurrency = items.find(i => typeof i.unitPrice === 'number' && i.unitPrice > 0)?.currency || (window.Shopify?.currency?.active) || 'GBP';
        const grandTotal = items.reduce((sum, i) => sum + ((i.unitPrice || 0) * (i.qty || 0)), 0);
        const totalEl = document.createElement('div');
        totalEl.className = 'cc-total mt-2 pt-2 border-t border-gray-200 text-right font-semibold';
        totalEl.innerHTML = `<span>Total:</span> <span class="ml-2">${formatMoney(grandTotal, firstCurrency)} + VAT</span>`;
        mount.appendChild(totalEl);
    }

    function syncMeshKitsUI(formEl) {
        const mode = selectedVal(formEl, 'units-');
        const field = formEl.querySelector('[data-role="mesh-kits-field"]');
        const wrap = formEl.querySelector('[data-role="mesh-kits-qty-wrapper"]');
        const input = formEl.querySelector('[data-role="mesh-kits-qty-input"]');
        const hint = formEl.querySelector('[data-role="mesh-kits-requirement-text"]');
        if (!field || !wrap || !hint) return;

        if (mode !== 'kits') {
            wrap.style.display = 'none';
            if (input) input.value = '';
            return;
        }

        const meshMode = selectedVal(formEl, 'meshmode-') || 'none';
        const needsQty = (meshMode !== 'none');

        wrap.style.display = needsQty ? '' : 'none';

        if (!needsQty) {
            if (input) input.value = '';
            hint.textContent = '';
            return;
        }

        if (meshMode === 'overlay') {
            hint.textContent = 'Mesh is required for overlay';
        } else if (meshMode === 'vubamac') {
            hint.textContent = 'Mesh is required for vubamac';
        } else {
            hint.textContent = '';
        }
    }

    // ---------- Add to Cart ----------
    async function addToCartFromForm(formEl, btnEl) {
        const resultsBox = formEl.querySelector('.coverage-calculator__form--results');
        clearErrors(resultsBox);

        const state = computeState(formEl);

        if (!state.isToppingNeeded) {
            if (state.vmQty <= 0) {
                showError(resultsBox, 'You have opted out of the stone topping. Please select VubaMac Base and enter a quantity.');
                return;
            }
        } else {
            if (!(state.bags > 0)) {
                showError(resultsBox, 'Please enter an area and options that produce at least 1 bag.');
                return;
            }
            if (!state.colorVid) {
                showError(resultsBox, 'Please choose a colour.');
                return;
            }
        }

        const lines = collectCartLines(state);
        if (!lines.length) {
            showError(resultsBox, 'Nothing to add. Please review your selections.');
            return;
        }

        // --- Build properties for the colour line from metafields ---
        const colorDatum = state.colorDatum || {};
        const colorKit = state.colorKit || {};

        // Prefer the kit object from computeState, fall back to raw metafields on colorDatum
        const bag1 = colorKit.bag1 || colorDatum.kitItem1 || '';
        const bag2 = colorKit.bag2 || colorDatum.kitItem2 || '';
        const bag3 = colorKit.bag3 || colorDatum.kitItem3 || '';
        const bag4 = colorKit.bag4 || colorDatum.kitItem4 || '';

        // const getSurchargeId = (sid) => {
        //     if (!sid) return null;
        //     const parts = String(sid).split('/');
        //     return parts[parts.length - 1] || null;
        // };
        const bagProps = {
            'bag-1': String(bag1),
            'bag-2': String(bag2),
            'bag-3': String(bag3),
            'bag-4': String(bag4),
            // '_surcharge_id': getSurchargeId(colorDatum.surchargeId)
        };

        // --- Map calculator lines cart/add.js items, attaching properties only to colour line ---
        const items = lines
            .map(l => {
                const numericId = gidToNumeric(l.id);
                if (!numericId || !(l.quantity > 0)) return null;

                const isColourLine = (l.id === state.colorVid);

                const base = {
                    id: numericId,
                    quantity: l.quantity
                };

                // Add flags if it's base only (no topping)
                if (!state.isToppingNeeded) {
                    base.properties = base.properties || {};
                    base.properties['_order_type'] = 'VubaMac Base Only';
                    base.properties['_notice'] = 'Customer ordered base without topping';
                }

                if (isColourLine) {
                    // Always attach properties to the colour line
                    return {
                        ...base,
                        properties: bagProps
                    };
                }

                return base;
            })
            .filter(Boolean);

        if (!items.length) {
            showError(resultsBox, 'Nothing to add. Please review your selections.');
            return;
        }

        // Debug: see exactly what we’re sending to Shopify
        console.log('[Coverage calculator] colour metafields:', {
            colorHandle: state.colorHandle,
            colorVid: state.colorVid,
            colorDatum
        });
        console.log('[Coverage calculator] cart/add.js payload:', { items });

        try {
            setLoading(btnEl, true);

            // Base payload
            const payload = { items };

            // If continuation info is present, add / merge into cart note
            if (state.continuationEnabled && state.continuationOrderNumber) {
                let noteText = `Continuation order: ${state.continuationOrderNumber}`;

                try {
                    // Try to preserve any existing cart note
                    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
                    if (cartRes.ok) {
                        const cartJson = await cartRes.json();
                        const existingNote = cartJson?.note ? String(cartJson.note).trim() : '';

                        if (existingNote) {
                            if (!existingNote.includes(noteText)) {
                                noteText = `${existingNote}\n${noteText}`;
                            } else {
                                // If it's already in there, just keep the existing note
                                noteText = existingNote;
                            }
                        }
                    }
                } catch (e) {
                    console.warn('[Coverage calculator] unable to read existing cart note', e);
                    // fall back to just the continuation note
                }

                payload.note = noteText;
            }

            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                const msg = err?.description || err?.message || 'Unable to add to cart. Please try again.';
                showError(resultsBox, msg);
                return;
            }

            window.location.href = '/cart';
        } catch (e) {
            console.error('[Coverage calculator] add to cart failed:', e);
            showError(resultsBox, 'Network error adding to cart. Please try again.');
        } finally {
            setLoading(btnEl, false);
        }
    }

    // ---------- Init & wiring ----------
    function initOneForm(formEl) {
        if (!formEl || formEl._ccCardsInit) return;
        formEl._ccCardsInit = true;

        // Clear VubaMac m² field on init to prevent cached values
        const vmM2Input = formEl.querySelector('[data-role="vubamac-m2-input"]');
        if (vmM2Input) vmM2Input.value = '';

        const unitsRadios = formEl.querySelectorAll('input[type="radio"][name^="units-"]');
        unitsRadios.forEach(r => {
            r.addEventListener('change', () => {
                rerender(); // ensures mesh qty wrapper + hint are set immediately
            }, { passive: true });
        });

        // Initial sync
        syncUnitsUI(formEl);
        const rerender = () => {
            syncUnitsUI(formEl);
            syncMeshKitsUI(formEl);
            buildAndRender(formEl);
        };
        const areaInput = formEl.querySelector('input[type="number"][id^="ref-"]');
        const colorSelect = formEl.querySelector('select[id^="color-"]');
        const ctaBtn = formEl.querySelector('#calculator-add-to-cart');
        const continuationCheckbox = formEl.querySelector('input[type="checkbox"][data-role="continuation-checkbox"]');

        const continuationWrapper = formEl.querySelector('[data-role="continuation-wrapper"]');
        if (continuationCheckbox && continuationWrapper) {
            const toggleContinuation = () => {
                continuationWrapper.style.display = continuationCheckbox.checked ? '' : 'none';
                rerender();
            };
            continuationCheckbox.addEventListener('change', toggleContinuation, { passive: true });
            toggleContinuation(); // set initial state
        }

        const vmQtyInput = formEl.querySelector('[data-role="vubamac-qty-input"]');
        if (vmQtyInput) {
            vmQtyInput.addEventListener('input', rerender, { passive: true });
            vmQtyInput.addEventListener('change', rerender, { passive: true });
        }

        if (vmM2Input) {
            vmM2Input.addEventListener('input', rerender, { passive: true });
            vmM2Input.addEventListener('change', rerender, { passive: true });
        }
        if (areaInput) { areaInput.addEventListener('input', rerender, { passive: true }); areaInput.addEventListener('change', rerender, { passive: true }); }
        if (colorSelect) { colorSelect.addEventListener('change', rerender, { passive: true }); }
        const meshOptOutM2 = formEl.querySelector('input[type="checkbox"][data-role="mesh-optout-m2"]');
        if (meshOptOutM2) meshOptOutM2.addEventListener('change', rerender, { passive: true });

        formEl.querySelectorAll('input[type="radio"][name^="meshmode-"]').forEach(r => {
            r.addEventListener('change', rerender, { passive: true });
        });

        const meshKitsQtyInput = formEl.querySelector('[data-role="mesh-kits-qty-input"]');
        if (meshKitsQtyInput) {
            meshKitsQtyInput.addEventListener('input', rerender, { passive: true });
            meshKitsQtyInput.addEventListener('change', rerender, { passive: true });
        }
        ['depth-', 'kits-depth-', 'overage-', 'resin-', 'grade-', 'vubamac-', 'vm-overage-', 'topping-'].forEach(prefix => {
            formEl.querySelectorAll(`input[type="radio"][name^="${prefix}"]`).forEach(r =>
                r.addEventListener('change', rerender, { passive: true })
            );
        });

        const tcCb = formEl.querySelector('input[type="checkbox"][data-role="trowel-cleaner-checkbox"]');
        if (tcCb) tcCb.addEventListener('change', rerender, { passive: true });

        if (ctaBtn) {
            ctaBtn.addEventListener('click', (e) => {
                e.preventDefault();
                addToCartFromForm(formEl, ctaBtn);
            });
        }



        rerender();
    }

    function showLoading(mount) {
        mount.innerHTML = `
    <div class="cc-loading flex items-center gap-3 p-3 rounded-xl border border-gray-200">
      <span class="cc-spinner" aria-hidden="true"></span>
      <span>Calculating…</span>
    </div>
  `;
    }

    function initAll() {
        document.querySelectorAll('.coverage-calculator__form').forEach(initOneForm);
    }

    document.addEventListener('DOMContentLoaded', initAll, { passive: true });
    document.addEventListener('shopify:section:load', initAll, { passive: true });

    const css = `
  .coverage-calculator__form--results .coverage-calculator__product-list { margin-top:.75rem; }
  .coverage-calculator__form--results .cc-card { background:#fff; }
  .coverage-calculator__form--results .cc-errors { margin-bottom:.5rem; }
  .cc-spinner {
    display:inline-block; width:1rem; height:1rem; border-radius:9999px;
    border:2px solid #fff; border-right-color:transparent; animation: cc-spin .6s linear infinite;
  }
  @keyframes cc-spin { to { transform: rotate(360deg); } }
  @media (prefers-color-scheme: dark) {
    .cc-spinner { border-color:#fff; border-right-color:transparent; }
  }
`;
    const style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);
})();